import { ProtectedRoute } from "@/components/protected-route";
import { MapComponent } from "./map";

export default function Dashboard() {
  return (
    <ProtectedRoute>
      <div className="absolute inset-0">
        <MapComponent />
      </div>
    </ProtectedRoute>
  );
}
